<template>
  <v-alert class="stat-card" elevation="0" rounded="xl">
    <div class="card-content">
      <div class="card-body">
        <!-- Bagian kanan: teks -->
        <div class="text-wrapper">
          <div class="card-header">
            <span class="title-text">{{ title.toUpperCase() }}</span>
          </div>

          <div class="number-group">
            <span class="main-number">{{ number }}</span>
            <span class="unit-text" v-if="unit">{{ unit }}</span>
          </div>

          <div class="card-footer" v-if="desc">
            {{ desc }}
          </div>
        </div>
        <!-- Ikon di kiri -->
        <div class="icon-wrapper">
          <v-icon v-if="icon" :color="color" size="42" class="icon">{{
            icon
          }}</v-icon>
          <v-avatar
            v-else-if="initial"
            :color="color"
            size="42"
          >
            <span class="white--text text-h6">{{ initial }}</span>
          </v-avatar>
        </div>
      </div>
    </div>
  </v-alert>
</template>

<script>
export default {
  props: {
    number: { type: [String, Number], default: "" },
    title: { type: String, default: "Title" },
    unit: { type: String, default: "" },
    desc: { type: String, default: "" },
    icon: { type: String, default: "" },
    color: { type: String, default: "#00eaff" },
    initial: { type: String, default: "" },
    numberClass: { type: String, default: "text-h4" },
  },
};
</script>

<style scoped>
/* ====== Card Wrapper ====== */
.stat-card {
  position: relative;
  background-color: #05182d;
  color: #00eaff;
  border: 2px solid transparent;
  border-radius: 16px;
  background-clip: padding-box;
  padding: 18px 24px;
  transition: all 0.3s ease;
  overflow: hidden;
}

.stat-card::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 16px;
  padding: 2px;
  background: linear-gradient(90deg, #ff9100, #00eaff, #ff9100);
  background-size: 300% 300%;
  animation: borderFlow 6s linear infinite;
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  pointer-events: none;
}

@keyframes borderFlow {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.stat-card:hover {
  box-shadow: 0 0 16px rgba(0, 234, 255, 0.25);
}

.card-content {
  width: 100%;
  position: relative;
  z-index: 1;
}

/* ====== Layout Utama ====== */
.card-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

/* ====== Ikon ====== */
.icon-wrapper {
  display: flex;
  /* align-items: center; */
  /* justify-content: center; */
}

.v-icon {
  background: transparent !important;
  box-shadow: none !important;
  border: none !important;
}

/* ====== Teks di kanan ikon ====== */
.text-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
}

.card-header .title-text {
  font-size: 0.85rem;
  font-weight: 700;
  color: #00eaff;
  opacity: 0.9;
}

.number-group {
  display: flex;
  align-items: baseline;
  margin-top: 4px;
}

.main-number {
  font-size: 1.8rem;
  font-weight: 700;
  color: #00eaff;
  line-height: 1.2;
}

.unit-text {
  font-size: 1rem;
  color: #00eaff;
  margin-left: 4px;
}

.card-footer {
  font-size: 0.75rem;
  color: #00eaff;
  opacity: 0.8;
  margin-top: 2px;
}

@media (min-width: 960px) {
  .stat-card {
    min-height: 130px;
  }
}
</style>
